import useURLs from '@api/hooks/useURLs';
import { getUnLiveUrl } from '@api/selectors/urls';
import PropTypes from 'prop-types';
import { createContext } from 'react';

export const Context = createContext();

export const PlannerItemContextProvider = ({
  children,
  goalUID,
  refreshFeatureCards,
  itemsFetcherWorkerRef,
  staleEventsMapRef,
  showActionMenu,
  closeActionMenu,
  menuAnchorEl,
  selectedItemRef
}) => {
  const unLiveURL = useURLs(getUnLiveUrl);

  const data = {
    refreshFeatureCards,
    staleEventsMapRef,
    itemsFetcherWorkerRef,
    selectedGoalUID: goalUID,
    unLiveURL,
    showActionMenu,
    closeActionMenu,
    menuAnchorEl,
    selectedItemRef
  };
  return <Context.Provider value={data}>{children}</Context.Provider>;
};

PlannerItemContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  refreshFeatureCards: PropTypes.func.isRequired,
  goalUID: PropTypes.string,
  itemsFetcherWorkerRef: PropTypes.shape({}),
  staleEventsMapRef: PropTypes.shape({})
};

PlannerItemContextProvider.defaultProps = {
  goalUID: '',
  itemsFetcherWorkerRef: null,
  staleEventsMapRef: null
};
